import { render, staticRenderFns } from "./FabMenuIcon.vue?vue&type=template&id=970bfa22&scoped=true"
import script from "./FabMenuIcon.vue?vue&type=script&lang=js"
export * from "./FabMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970bfa22",
  null
  
)

export default component.exports